import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ConfidenceSection from "./components/ConfidenceSection";

import HomeSupplyPreview from "./components/HomeSupplyPreview";
import HomeStatsSection from "./components/HomeStatsSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get("scrollTo");
    if (scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [location.search]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <HomeSupplyPreview />
        <HomeStatsSection />
        <HowItWorksSection />
        <ConfidenceSection />

      </main>
      <Footer />
    </div>
  );
}